import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModalWindowOfferParams, setTermsModalData, setTermsModalOpen } from 'shared/redux/landingSlice';
import { selectModalWindowRedirectParams } from 'shared/selectors/landing/selectModalWindowOfferParams';
import { selectIsTermsModalOpen, selectTermsModalData } from 'shared/selectors/landing/selectTermsModal';
import { IShortOfferTermsModalData } from 'shared/types/features/landing';
import { IFillApplicationActionProps, useFillApplicationAction } from '../useFillApplicationAction';

export const useShortOfferTermsModal = () => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(selectIsTermsModalOpen);
  const termsModalData = useSelector(selectTermsModalData);
  const modalWindowOfferParams = useSelector(selectModalWindowRedirectParams);
  const { fillApplicationAction, isPending } = useFillApplicationAction();

  const handleModalClose = useCallback(() => {
    dispatch(setTermsModalOpen(false));
    dispatch(setTermsModalData(null));
    dispatch(setModalWindowOfferParams(null));
  }, [dispatch]);

  const handleModalOpen = useCallback(
    (data: IShortOfferTermsModalData, fillApplicationParams?: IFillApplicationActionProps) => {
      dispatch(setTermsModalData(data));
      dispatch(setTermsModalOpen(true));

      if (fillApplicationParams) {
        dispatch(setModalWindowOfferParams(fillApplicationParams));
      }
    },
    [dispatch],
  );

  const handleFillApplicationClick = useCallback(() => {
    if (!modalWindowOfferParams) {
      return;
    }

    void fillApplicationAction(modalWindowOfferParams);
  }, [fillApplicationAction, modalWindowOfferParams]);

  return {
    isModalOpen,
    isPending,
    termsModalData,
    handleModalClose,
    handleModalOpen,
    handleFillApplicationClick,
  };
};
